import apiClient from './apiClient';
import {
  AdminUserStats,
  UserWithLogtoStatus,
  AdminUserListResponse,
  NonSyncResponse,
  OrganizationWithUsers,
  User,
} from '../types';
import type { AdminUserListParams } from '../types/adminUsers';

const apiBaseURL = '/admin/users';

export const adminUsersService = {
  getStats: async (): Promise<AdminUserStats> => {
    const response = await apiClient.get<AdminUserStats>(`${apiBaseURL}/stats`);
    return response.data;
  },

  // Axios drops undefined params, so unset filters are simply not sent.
  getList: async (params: AdminUserListParams): Promise<AdminUserListResponse> => {
    const response = await apiClient.get<AdminUserListResponse>(`${apiBaseURL}/list`, { params });
    return response.data;
  },

  getNonSync: async (): Promise<NonSyncResponse> => {
    const response = await apiClient.get<NonSyncResponse>(`${apiBaseURL}/non-sync`);
    return response.data;
  },

  getOrganizationsWithMembers: async (): Promise<OrganizationWithUsers[]> => {
    const response = await apiClient.get<OrganizationWithUsers[]>(`${apiBaseURL}/organizations-with-members`);
    return response.data;
  },

  getDemoUsers: async (params?: { skip?: number; limit?: number }): Promise<AdminUserListResponse> => {
    const response = await apiClient.get<AdminUserListResponse>(`${apiBaseURL}/demo`, { params });
    return response.data;
  },

  addUserFromLogto: async (logtoId: string, organizationId?: string | null): Promise<User> => {
    const response = await apiClient.post<User>(`${apiBaseURL}/from-logto`, {
      logto_id: logtoId,
      organization_id: organizationId || null,
    });
    return response.data;
  },

  deleteLogtoUser: async (logtoId: string): Promise<{ message: string; logto_id: string }> => {
    const response = await apiClient.delete<{ message: string; logto_id: string }>(`${apiBaseURL}/logto/${logtoId}`);
    return response.data;
  },
};

export default adminUsersService;
